import React from 'react';

const icons = {
  travel: (
    <svg viewBox="0 0 40 40" role="presentation">
      <circle className="ft-theme-icon__accent" cx="9" cy="29" r="3.25" />
      <circle cx="28.5" cy="10.5" r="3.25" />
      <path d="M12.3 28.2c6.8-1.4 3.1-10.5 9.5-12.1 2.7-.7 4.7.3 6.7-2.3" />
      <path d="m24.8 9.9 4.2.3-.4 4.1" />
      <path className="ft-theme-icon__fine" d="M7 8.5h7M7 12h4" />
    </svg>
  ),
  habit: (
    <svg viewBox="0 0 40 40" role="presentation">
      <path d="M30.5 15.2a11.2 11.2 0 1 0 .5 9.1" />
      <path d="m27.4 10.3 3.7 5.1-6.1.8" />
      <path d="M8.7 21h6.1l2.4-5.5 4.2 11 2.8-5.5h7.1" />
      <circle className="ft-theme-icon__accent" cx="20" cy="20.8" r="2.15" />
    </svg>
  ),
  validation: (
    <svg viewBox="0 0 40 40" role="presentation">
      <path className="ft-theme-icon__fine" d="M7 14V8h6M27 8h6v6M33 26v6h-6M13 32H7v-6" />
      <circle cx="20" cy="20" r="9" />
      <circle className="ft-theme-icon__accent" cx="20" cy="20" r="3" />
      <path d="m16 20 2.7 2.8 5.8-6.2" />
    </svg>
  ),
  daily: (
    <svg viewBox="0 0 40 40" role="presentation">
      <rect x="7" y="7" width="10" height="10" rx="2" />
      <rect className="ft-theme-icon__accent" x="23" y="7" width="10" height="10" rx="2" />
      <rect x="7" y="23" width="10" height="10" rx="2" />
      <path d="M23 23h10v10H23zM17 12h6M12 17v6M28 17v6M17 28h6" />
    </svg>
  ),
};

const ThemeIcon = ({ theme }) => (
  <span className="ft-theme-icon" aria-hidden="true">
    <span className="ft-theme-icon__grid" />
    {icons[theme] ?? icons.daily}
    <i />
  </span>
);

export default ThemeIcon;
